import React, { useState, useEffect, ReactNode } from 'react';
import ReactDOM from 'react-dom';

// Adjust path
import App from '@plasma/ui.application.app';
import { plasmaInterpreters, PlasmaInterpreters } from '@plasma/ui.application.plasma-provider';
import { GlobalInterpreterStore } from '@plasma/ui.interpreters.global-interpreter';
import { LocalStorageSettingsStore } from '@plasma/ui.utils.settings-store';

import { applications } from './applications';
import LoadingComponent from './components/Loding-component/LoadingComponent';
import { translations } from './i18n';
import { menuItems } from './menu';
//import { routes } from './routes';

import KeycloakWrapper from './services/Auth/getAuthentication';
import { apiUriMasterDataHttp } from './services/conf/apiConf';
import { fetchAllDataGet_byApiName } from './services/gets/getdata'; // Adjust path
import { plantDataType } from './types/plantLayoutType';

const applicationId = '${REPO_NAME}';

const superUserRole = sessionStorage.getItem('superUserRole');

// Suppress benign ResizeObserver errors caused by auto-resizing grid/chart components
window.addEventListener('error', (e) => {
  if (
    e.message === 'ResizeObserver loop limit exceeded' ||
    e.message === 'ResizeObserver loop completed with undelivered notifications.'
  ) {
    e.stopImmediatePropagation();
  }
});

const renderLogoElements = (keycloakWrapperdata: any): ReactNode[] => {
  //console.log("ckecking key cloack",keycloakWrapperdata);
  const returnElement: ReactNode = (
    <div style={{ display: 'flex', alignItems: 'center' }} key={'keyclockLogo'}>
      {keycloakWrapperdata.logoandtitle.useLogo && (
        <div style={{ fontSize: '1.25rem', fontWeight: '500', marginRight: '1vw' }}>ADMIN MODE</div>
      )}
      <img src={keycloakWrapperdata.logoandtitle.logo} alt="" height={'43vh'} />
    </div>
  );
  return [returnElement];
};

// Define the shape of your memory instance
export const PlantLayoutContext = React.createContext<{ layoutData: plantDataType[]; isLoading: boolean } | null>(null);

const PlantLayoutProvider = ({ children }: { children: React.ReactNode }) => {
  const [layoutData, setLayoutData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    // This calls the API exactly once when the app starts
    fetchAllDataGet_byApiName('GetPlantLayout', apiUriMasterDataHttp())
      .then((data) => {
        setLayoutData(data); // Saved to memory
        setIsLoading(false); // Set loading to false once data is received
      })
      .catch((err) => {
        console.error('Initial Load Error:', err);
        setLayoutData([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return <PlantLayoutContext.Provider value={{ layoutData, isLoading }}>{children}</PlantLayoutContext.Provider>;
};

const AppWrapper = () => {
  return (
    <KeycloakWrapper>
      {(keycloakWrapperdata: any) =>
        keycloakWrapperdata.authenticated && keycloakWrapperdata.user ? (
          <PlantLayoutProvider>
            <App
              id={applicationId}
              routes={keycloakWrapperdata.authenticated ? keycloakWrapperdata.routes : []}
              menu={menuItems}
              applications={applications(keycloakWrapperdata.logoandtitle.title, keycloakWrapperdata.logoandtitle.logo)}
              translations={translations}
              isAuthenticated={keycloakWrapperdata.authenticated}
              unauthorizedRedirectPath="/login"
              preferences={{
                theme: { options: ['light', 'dark'], default: 'dark' },
                size: {
                  options: ['small', 'medium', 'large'],
                  default: 'medium',
                },
                menu: { options: ['side', 'top'], default: 'side' },
                language: {
                  options: ['en-US', 'es-SP', 'bn-IN', 'hn-IN'],
                  default: 'en-US',
                },
              }}
              settingsStore={new LocalStorageSettingsStore(applicationId)}
              interpreterStore={new GlobalInterpreterStore<PlasmaInterpreters>(plasmaInterpreters)}
              user={keycloakWrapperdata.user}
              avatarConfig={keycloakWrapperdata.avatarConfigs}
              workspaceHeaderExtras={renderLogoElements(keycloakWrapperdata)}
            />
          </PlantLayoutProvider>
        ) : (
          <LoadingComponent />
        )
      }
    </KeycloakWrapper>
  );
};

ReactDOM.render(<AppWrapper />, document.getElementById('root'));
